import { useState, useEffect } from 'react';
import { useKakaoLoader as useKakaoLoaderOrigin } from 'react-kakao-maps-sdk';
import { Config } from '@/config';

export default function useKakaoLoader() {
  return useKakaoLoaderOrigin({
    appkey: `${Config.KAKAO_MAP_APP_KEY}`,
    libraries: ['clusterer', 'drawing', 'services'],
  });
}
